import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Box = styled.div<{ $isFooterPresented?: boolean }>`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  padding: 0 100px 0 20px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  ${({ $isFooterPresented }) =>
    $isFooterPresented &&
    css`
      flex: 0 0 auto;
      height: 550px;
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled(Typography.Header).attrs({
  $variant: '0',
})`
  margin: 40px 0 15px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 25px 0 15px;
  }
`;

export const Text = styled(Typography.Caption).attrs({
  $variant: '1',
})`
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const Action = styled(Button)`
  margin-top: 20px;
`;
